import { useCallback } from 'react';
import { EndPoints } from 'src/config';
import { isShippingTracker } from 'src/helpers';
import { useFetcher } from 'src/hooks/useFetcher';
import { SearchForPrintResult } from './printOnDemand.types';


export type SearchForPrintBodyRequest = { shippingTracker : string } | {coliTracker:string};

export const usePrintOnDemandSearch = () => {
    const {isLoading, error, fetcher, data, resetData} = useFetcher<SearchForPrintResult>([]);

    const bodyRequest = (tracker:string):SearchForPrintBodyRequest => {
        if(isShippingTracker(tracker)){
            return {
                shippingTracker:tracker
            }
        } 

        return {
            coliTracker:tracker
        }
    }

    const getPrintFromSearch = useCallback((tracker:string)=> {
        fetcher(EndPoints.searchForPrint, {
            requiredToken:true,
            body: bodyRequest(tracker),
        })
    },[fetcher]);

    return {
        isLoading,
        error,
        getPrintFromSearch,
        data,
        resetData
    }
}